import React, { useState } from "react";
import { Typography, Box, IconButton, Card, CardContent } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SettingsIcon from "../../assets/images/adminSection/settings.svg";
import BarChartIcon from "../../assets/images/adminSection/bar.svg";
import REImagine from "../../assets/images/adminSection/REImagine.svg";
import RandRIcon from "../../assets/images/adminSection/R&RIcon.svg";
import policyIcon from "../../assets/images/adminSection/policy.svg";

import { Grid } from "@material-ui/core";
import IdeaCaptureConfig from "../adminModals/REImagine/IdeaCaptureConfig";

const AdminSection: React.FC = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState<"RandR" | "REImagine" | null>(
    null
  );

  const handleOpen = (type: "RandR" | "REImagine") => {
    setOpenModal(type);
  };

  const handleClose = () => {
    setOpenModal(null);
  };

  const handleSave = () => {
    setOpenModal(null);
  };

  return (
    <Box sx={{ m: 3 }}>
      {/* Rewards and Recognition */}
      <Card
        sx={{
          backgroundColor: "#4F4F4F",
          mb: 2,
          borderRadius: 0,
          boxShadow: "none",
        }}
      >
        <CardContent>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <img src={RandRIcon} alt="img" />
            </Grid>
            <Grid item xs>
              <Typography
                className="f-16"
                sx={{ color: "#ffffff", fontWeight: "700" }}
              >
                Rewards and Recognition
              </Typography>
              {/* <Typography
                className="f-12"
                sx={{ color: "#ffffff", mt: 1, fontWeight: "400" }}
              >
                Last updated on: 06 Feb 12:47 PM, by HappierWork Support
              </Typography> */}
            </Grid>
            <Grid item>
              <IconButton onClick={() => navigate("/RandRDashboard")}>
                <img src={BarChartIcon} alt="bar chart" />
              </IconButton>
              <IconButton onClick={() => navigate("/BudgetDashboard")}>
                <img src={SettingsIcon} alt="settings" />
              </IconButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* RE Imagine */}
      <Card
        sx={{
          backgroundColor: "#4F4F4F",
          mb: 2,
          borderRadius: 0,
          boxShadow: "none",
        }}
      >
        <CardContent>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <img src={REImagine} alt="img" />
            </Grid>
            <Grid item xs>
              <Typography
                className="f-16"
                sx={{ color: "#ffffff", fontWeight: "700" }}
              >
                RE Imagine
              </Typography>
              {/* <Typography
                className="f-12"
                sx={{ color: "#ffffff", mt: 1, fontWeight: "400" }}
              >
                Last updated on: 06 Feb 12:47 PM, by HappierWork Support
              </Typography> */}
            </Grid>
            <Grid item>
              <IconButton onClick={() => navigate("/reImagineDashboard")}>
                <img src={BarChartIcon} alt="bar chart" />
              </IconButton>
              <IconButton onClick={() => handleOpen("REImagine")}>
                <img src={SettingsIcon} alt="settings" />
              </IconButton>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {/* Policy Dashboard */}
      <Card
        sx={{
          backgroundColor: "#4F4F4F",
          mb: 2,
          borderRadius: 0,
          boxShadow: "none",
        }}
      >
        <CardContent>
          <Grid
            container
            alignItems="center"
            spacing={2}
            onClick={() => navigate("/policyDashboard")}
            style={{ cursor: "pointer" }}
          >
            <Grid item>
              <img src={policyIcon} alt="img" />
            </Grid>
            <Grid item xs>
              <Typography
                className="f-16"
                sx={{ color: "#ffffff", fontWeight: "700" }}
              >
                Policies & Procedures
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Modal for RE Imagine Settings */}
      {openModal && (
        <IdeaCaptureConfig
          open={Boolean(openModal)}
          onClose={handleClose}
          onSave={handleSave}
        />
      )}
    </Box>
  );
};

export default AdminSection;
